<template>
    <!-- <v-sheet :elevation="24" :height="200" :width="200" width="400px" height="250px"> -->
      <v-card elevation="16"  height="210px">
        <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'350px'" :h="'200px'"
                   :disabled="state.disabled" class="example">
        </Vue3Signature>
        <template v-slot:actions>
          <!-- <v-btn @click="handleDisabled()" block  color="success">Valider</v-btn>  -->
          <v-btn style="margin-top: -100px;" @click="save('./image.jpeg')" block  color="success">{{ $t('signer') }}</v-btn>
          <!-- <v-btn @click="undo()" block  color="warning">Annuler</v-btn> -->
        </template>
      </v-card>
        
    <!-- </v-sheet> -->
    
    <!-- <v-row >
        <v-col cols="12" md="4">
            <v-btn @click="handleDisabled()" block  color="success">Valider</v-btn> 
        </v-col>
        <v-col cols="12" md="3">
            <v-btn @click="save('./image.jpeg')" block  color="success">Terminer</v-btn>
        </v-col>
        <v-col cols="12" md="3">
            <v-btn @click="undo()" block  color="warning">Annuler</v-btn>
        </v-col>
    </v-row> -->
    
  </template>
  
  <script setup>
  import {reactive, ref} from 'vue'
  import store from './store'
  const state = reactive({
    count: 0,
    option: {
      penColor: "rgb(0, 0, 0)",
      backgroundColor: "rgb(255,255,255)"
    },
    disabled: false
  })
  
  const signature1 = ref(null)
  
  const save = (t) => {
    store.commit('addSignature',{exist:true,link:signature1.value.save(t)})
  }
  
  const clear = () => {
    signature1.value.clear()
  }
  
  const undo = () => {
    signature1.value.undo();
  }
  
  const addWaterMark = () => {
    signature1.value.addWaterMark({
      text: "mark text",          // watermark text, > default ''
      font: "20px Arial",         // mark font, > default '20px sans-serif'
      style: 'all',               // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
      fillStyle: "red",           // fillcolor, > default '#333'
      strokeStyle: "blue",	       // strokecolor, > default '#333'
      x: 100,                     // fill positionX, > default 20
      y: 200,                     // fill positionY, > default 20
      sx: 100,                    // stroke positionX, > default 40
      sy: 200                     // stroke positionY, > default 40
    });
  }
  
  const fromDataURL = (url) => {
    signature1.value.fromDataURL("https://avatars2.githubusercontent.com/u/17644818?s=460&v=4");
  }
  
  const handleDisabled = () => {
    state.disabled = !state.disabled
  }
  
  </script>
  
  <style scoped>
  .example{
    margin: 0 auto;
  }
  </style>